import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[200]};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-grow: 1;
  gap: ${theme.remSize[200]};
`;

export const textInfo: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.remSize[50]};
`;

export const details: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[50]};
  flex-direction: column;
`;
